var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var DEFAULT_LANG = 'ja';

//console.log(Shopify);
const activeLocale = Shopify.locale;
//console.log(activeLocale);
var pathname = window.location.pathname;
var lang= pathname.split("/");
if (!pathname.includes(activeLocale)) {
  DEFAULT_LANG = '';
}

var selectorsWishlist = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', function (event) {
  //console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener(
  'shopify-wishlist:init-product-grid',
  function (event) {
    /*console.log(
      '[Shopify Wishlist] Wishlist Product List Loaded ✅',
      event.detail.wishlist
    );*/
  }
);

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
  /* console.log(
    '[Shopify Wishlist] Wishlist Buttons Loaded ✅',
    event.detail.wishlist
  ); */
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();

  // wishlist button in header
  var buttoncart = document.querySelectorAll('#button-wishlist-cart') || false;
  var buttoncartMobile = document.querySelectorAll('#button-wishlist-cart-mobile') || false;
  const wishlistLen = wishlist.length;
  const wishlistPageHeight = Math.ceil((wishlistLen / 5)) * 436 //422+14
  if (wishlistLen > 0) {
    if (buttoncart) {
        buttoncart.forEach(item => {
          item.classList.add(BUTTON_ACTIVE_CLASS);
        })        
    }
    if (buttoncartMobile) {
        buttoncartMobile.forEach(item => {
          item.classList.add(BUTTON_ACTIVE_CLASS);
        })        
    }

    
  } else {
    if (buttoncart) {
        buttoncart.forEach(item => {
          item.classList.remove(BUTTON_ACTIVE_CLASS);
        })
        
    }
    if (buttoncartMobile) {
        buttoncartMobile.forEach(item => {
          item.classList.remove(BUTTON_ACTIVE_CLASS);
        })    
    }
    
  }



  var numberofWish = document.getElementById('numberOfWish') || false;
  var numberofWishMobile = document.getElementById('numberOfWishMobile') || false;
  var wishlistText = document.getElementById('wishlist-text');
  
  if (numberofWish && numberofWishMobile ) {
    numberofWish.innerHTML = wishlist.length;
    numberofWishMobile.innerHTML = wishlist.length;

    if (wishlist.length > 0) {
      numberofWish.classList.remove('bg-none');
      numberofWishMobile.classList.remove('bg-none');
      numberofWish.classList.remove('d-none');
      numberofWishMobile.classList.remove('d-none');
      if (!wishlistText.classList.contains('d-none')) wishlistText.classList.add('d-none')
    } else {
      numberofWish.classList.add('bg-none');
      numberofWishMobile.classList.add('bg-none');
      numberofWish.classList.add('d-none');
      numberofWishMobile.classList.add('d-none');
      if (wishlistText.classList.contains('d-none')) wishlistText.classList.remove('d-none')
    }
  }
    
  var requests = wishlist.map(function (handle) {
    var prdUrl = '/products/' + handle + '.js';
    fetch(prdUrl)
      .then(resp => resp.json())
      .then(function (data) {
        //for modal
        //console.log(data);
        document.addEventListener('dispatchPrdWishlist', function (event) {
          //console.log(`registering productInfoAnchor ${data.id}`);
          getProductAnchors(`prdInfo-${data.id}`);
        });
      });

    var productTileTemplateUrl;
    var shoplocal = Shopify.locale;
    //console.log(shoplocal);
    if (DEFAULT_LANG == '') {
      productTileTemplateUrl = '/products/' + handle + '?view=wishlist';
    } else {
      productTileTemplateUrl =
        '/' + shoplocal + '/products/' + handle + '?view=wishlist';
    }

    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    //grid.setAttribute("style", `min-height:${wishlistPageHeight};`);
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist },
    });
    document.dispatchEvent(event);

    // Create a custom event and dispatch PopUp Modal for Wishlist items
    let myEvent = new CustomEvent('dispatchPrdWishlist', {
      bubbles: true,
      cancelable: true,
    });

    setTimeout(() => {
      const body = document.body;
      document.dispatchEvent(myEvent);
    }, 2);

    clearTimeout();
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    //console.log(productHandle);
    if (!productHandle)
      return console.error(
        '[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
      );

    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
      //console.log("add active");
    }

    button.addEventListener('click', function () {
      if (!updateWishlist(productHandle)) return false;
      //already toggled in update
      //button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

var updateWishlistContains = function (handle) {
  var wishlistUpdate = getWishlist();
  //console.log(wishlistUpdate);
    return wishlistUpdate.indexOf(handle) !== -1;
};
        
var updateButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    //console.log(productHandle);
    if (!productHandle)
      return console.error(
        '[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
      );
    
    if (updateWishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
      //console.log("add active");
    } else {
      if (button.classList.contains('active')) button.classList.remove(BUTTON_ACTIVE_CLASS);
    }
    
  });
};

var initGrid = function () {
  var grid = document.querySelector(selectorsWishlist.grid) || false;

  var wishlist = getWishlist();

  if (grid) {
    setupGrid(grid);
  } else {

    //wishlist button in header
    var buttoncart = document.querySelectorAll('#button-wishlist-cart') || false;
    if (wishlist.length > 0) {
      if (buttoncart) {
        buttoncart.forEach(item => {
          item.classList.add(BUTTON_ACTIVE_CLASS);
        })        
      }
    } else {
      if (buttoncart) {
        buttoncart.forEach(item => {
          item.classList.remove(BUTTON_ACTIVE_CLASS);
        })
        
      }
    }
  }

  var numberofWish = document.getElementById('numberOfWish') || false;
  var numberofWishMobile = document.getElementById('numberOfWishMobile') || false;
  var wishlistText = document.getElementById('wishlist-text') || false;
  
  if (numberofWish && numberofWishMobile ) {
    numberofWish.innerHTML = wishlist.length;
    numberofWishMobile.innerHTML = wishlist.length;

    if (wishlist.length > 0) {
      numberofWish.classList.remove('bg-none');
      numberofWishMobile.classList.remove('bg-none');
      numberofWish.classList.remove('d-none');
      numberofWishMobile.classList.remove('d-none');

      if (wishlistText) {
        if (!wishlistText.classList.contains('d-none')) wishlistText.classList.add('d-none');
      }
    
    } else {
      numberofWish.classList.add('bg-none');
      numberofWishMobile.classList.add('bg-none');
      numberofWish.classList.add('d-none');
      numberofWishMobile.classList.add('d-none');

      if (wishlistText) {
        if (wishlistText.classList.contains('d-none')) wishlistText.classList.remove('d-none');
      }
    }
  }
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectorsWishlist.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
  //console.log("done init btn");
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  //console.log(handle);
  var wishlist = getWishlist();
  
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) { 
    const wishLength = wishlist.length;
    //console.log(wishLength);
    if (wishLength > 19 ) {
      alert("There are 20 items in your whishlist. Remove some to make room for this one");
      return false;
    } else {
      wishlist.push(handle);
    }    
  } else { 
    wishlist.splice(indexInWishlist, 1);
  }
  setWishlist(wishlist);

  var numberofWish = document.getElementById('numberOfWish') || false;
  var numberofWishMobile = document.getElementById('numberOfWishMobile') || false;

  if (numberofWish && numberofWishMobile ) {
    numberofWish.innerHTML = wishlist.length;
    numberofWishMobile.innerHTML = wishlist.length;

    if (wishlist.length > 0) {
      numberofWish.classList.remove('bg-none');
      numberofWishMobile.classList.remove('bg-none');
      numberofWish.classList.remove('d-none');
      numberofWishMobile.classList.remove('d-none');
    } else {
      numberofWish.classList.add('bg-none');
      numberofWishMobile.classList.add('bg-none');
      numberofWish.classList.add('d-none');
      numberofWishMobile.classList.add('d-none');
    }
  }
  var buttonsUpdate = document.querySelectorAll(selectorsWishlist.button) || [];
  updateButtons(buttonsUpdate);
  return true;
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

